import en from './en.json';
import pt from './pt.json';
import fr from './fr.json';
import de from './de.json';
import es from './es.json';

const languages = { en, pt, fr, de, es };
export default languages;
